import Raven from 'raven-js';

export const log = (message: string, obj?: any) => {
  console.log(`>>> ${message}`, obj);
};

export const error = (message: string, error: any | Error) => {
  console.error(message, error);
  Raven.captureException(error);
};

export const capture = (message: string) => {
  console.log('>>> ', message);
  Raven.captureMessage(message);
};

export default {
  log,
  error,
  capture,
};
